// utils/pagination.js
export const normalizeMeta = (raw, params = {}, itemsLen = 0) => {
  const m = raw || {};
  const page = Number(m.page ?? params.page ?? 1);
  const page_size = Number(m.page_size ?? params.page_size ?? params.limit ?? 25);

  const skip = Number(m.skip ?? (page - 1) * page_size);
  const limit = Number(m.limit ?? page_size);

  const total = (m.total !== undefined)
    ? Number(m.total)
    : (m.total_pages !== undefined)
      ? Number(m.total_pages) * limit
      : undefined;

  let has_prev = m.has_prev;
  let has_next = m.has_next;

  if (total !== undefined) {
    const total_pages = Math.max(1, Math.ceil(total / limit));
    has_prev = page > 1;
    has_next = page < total_pages;
  } else {

    has_prev = skip > 0;
    has_next = itemsLen === limit; // 
  }

  return { page, page_size: limit, skip, limit, total, has_prev, has_next };
};

export const buildListParams = ({ page, page_size, ...extra }) => {
  const skip = (page - 1) * page_size;
  return {
    page,
    page_size,
    skip,
    limit: page_size,
    ...Object.fromEntries(Object.entries(extra).filter(([,v]) => v !== undefined)),
  };
};
